export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10967.9887d38c.jpg";